/**
 * 公共参数的配置文件
 * **/
import cookie from '@/utils/cookie'
import { md5 } from '@/utils/md5'
import ProjectConfigDetailData from '@/utils/global_val';

let newCfg , pwd= "Aabc@123";

const api = {
};

const config = {
  api,
  request: {
    channelType: "WEB",
    // terminalType: 'DSDS',    
    streamNoHead: "web_maya_",
    partnerCode: 'MAYA',
    mvnoCode: ''
  },
  currencyTypeMap: {
      jpy: '¥'
  },
  appDefaultLangType: 'en-US'
};

newCfg = Object.assign(config);

let set_ProjectConfig = function(config){
    let newConfig = Object.assign(config);

    //request配置
    newConfig.request.channelType = ProjectConfigDetailData.channelType || 'WEB';
    // newConfig.request.terminalType = ProjectConfigDetailData.terminalType || 'DSDS';
    newConfig.request.streamNoHead = "web_"+ProjectConfigDetailData.partnerCode;
    newConfig.request.partnerCode = ProjectConfigDetailData.partnerCode;
    newConfig.request.mvnoCode = cookie.getCookie('mvnoCode')||localStorage.getItem('mvnoCode')||ProjectConfigDetailData.mvnoCode;

    // appDefaultLangType 配置
    //newConfig.appDefaultLangType = ProjectConfigDetailData.langType || 'en-US';

    //密码配置
    pwd = ProjectConfigDetailData.password ? ProjectConfigDetailData.password : pwd;
    newConfig.password = md5(pwd).toLowerCase();
    
    return newConfig;
}

if(ProjectConfigDetailData){

  //ProjectConfigDetailData
  
  if(Object.keys(ProjectConfigDetailData).length){
    newCfg = set_ProjectConfig(config);
  }
}

if(!cookie.getCookie('appImei')){
  let time= 100*365
  let appImei= new Date().getTime() + parseInt(Math.random() * 1000000)
  cookie.setCookie('appImei',appImei,{ expires: time });
}

export default newCfg;
